import _regeneratorRuntime from "/home/vsts/work/1/s/client/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/home/vsts/work/1/s/client/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.array.find.js";
import { dbDataHandle } from '@/store/function/common/index';
import { getAvailabilityApi } from '@/api';

import downloadCsv from 'download-csv';
export default {
  name: 'PrepareRate',
  props: {
    filename: {
      type: String,
      default: '下載檔案'
    }
  },
  data: function data() {
    return {
      hasNoData: false,
      availability: [],
      tableField: [{
        key: 'date',
        label: '月份'
      }, {
        key: 'availabilityRateActual',
        label: '妥善率實際值 (%)'
      }, {
        key: 'availabilityRateGoal',
        label: '妥善率年度目標值 (%)'
      }, {
        key: 'accAvaiActual',
        label: '妥善率累積實際值 (%)'
      }],
      dataClassArr: ['妥善率實際值', '妥善率年度目標值', '妥善率累積實際值'],
      dataClass: ['妥善率實際值', '妥善率年度目標值', '妥善率累積實際值'],
      prepareRateChart: {
        chart: {
          height: 350,
          backgroundColor: null,
          events: {
            load: function load() {
              this.showLoading();
            }
          }
        },
        credits: {
          enabled: false
        },
        title: {
          text: ''
        },
        xAxis: {
          categories: []
        },
        plotOptions: {
          series: {
            dataLabels: {
              enabled: true
            }
          }
        },
        legend: {
          layout: 'horizontal',
          align: 'center',
          verticalAlign: 'top',
          floating: false
        },
        yAxis: [{
          title: {
            text: '妥善率 (%)'
          }
        }],
        tooltip: {
          shared: true
        },
        series: [{
          color: 'rgb(124,181,236)',
          type: 'column',
          name: '妥善率實際值 (%)',
          data: [],
          yAxis: 0,
          visible: true
        }, {
          color: 'rgb(255, 192, 0)',
          name: '妥善率年度目標值 (%)',
          data: [],
          yAxis: 0,
          visible: true
        }, {
          color: 'rgb(37, 84, 128)',
          name: '妥善率累積實際值 (%)',
          data: [],
          yAxis: 0,
          visible: true
        }],
        responsive: {
          rules: [{
            condition: {
              maxWidth: 500
            },
            chartOptions: {
              legend: {
                layout: 'horizontal',
                align: 'center',
                verticalAlign: 'bottom',
                y: 0
              }
            }
          }]
        }
      },
      availabilityForExcel: []
    };
  },
  methods: {
    getAvailability: function getAvailability(months) {
      var _this = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var _availability$data, availability;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.prepareRateChart.series.forEach(function (x) {
                  x.data = [];
                });
                _context.prev = 1;
                _context.next = 4;
                return getAvailabilityApi(_this.$route.query.fid, _this.$route.query.siteName + '.json', months);
              case 4:
                availability = _context.sent;
                if (availability !== null && availability !== void 0 && (_availability$data = availability.data) !== null && _availability$data !== void 0 && _availability$data.success) {
                  // 複製 availability、availabilityForExcel 不能 refer 同個 data
                  // renderData() 會改動 availability 資料

                  // 下載資料用
                  _this.availabilityForExcel = availability.data.data;

                  // 顯示圖表、表格用，copy 避免改動到 rawData (availability.data.data)
                  _this.availability = availability.data.data.map(function (item) {
                    var copy = Object.assign({}, item);
                    return copy;
                  });
                  _this.renderData();
                  _this.hasNoData = false;
                }
                _context.next = 13;
                break;
              case 8:
                _context.prev = 8;
                _context.t0 = _context["catch"](1);
                console.log('getAvailability error: ', _context.t0);
                _this.hasNoData = true;
                _context.t0.msg && _this.$swal(_context.t0.msg);
              case 13:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[1, 8]]);
      }))();
    },
    renderData: function renderData() {
      var _this2 = this;
      this.prepareRateChart.xAxis.categories = [];
      this.prepareRateChart.series.forEach(function (x) {
        x.data = [];
      });
      this.availability.forEach(function (x) {
        _this2.prepareRateChart.xAxis.categories.push(x.date);
        // 圖表、表格 是共用 this.availability 資料，直接 dbDataHandle 改變原始資料，顯示處理過的數據
        x.accAvaiActual = x.accAvaiActual === null ? null : dbDataHandle(x.accAvaiActual);
        x.availabilityRateActual = x.availabilityRateActual === null ? null : dbDataHandle(x.availabilityRateActual);
        x.availabilityRateGoal = x.availabilityRateGoal === null ? null : dbDataHandle(x.availabilityRateGoal);
        _this2.prepareRateChart.series[0].data.push(x.availabilityRateActual);
        _this2.prepareRateChart.series[1].data.push(x.availabilityRateGoal);
        _this2.prepareRateChart.series[2].data.push(x.accAvaiActual);
      });
      this.hideHighChartLoading();
    },
    hideHighChartLoading: function hideHighChartLoading() {
      this.$nextTick(function () {
        if (this.$refs && this.$refs.chart) {
          this.$refs.chart.chart.hideLoading();
          this.prepareRateChart.chart.events = {};
        }
      });
    },
    downloadAnalysis: function downloadAnalysis() {
      var downloadArr = [];
      var fields = ['name'];
      fields = fields.concat(this.prepareRateChart.xAxis.categories);
      this.prepareRateChart.series.forEach(function (x) {
        downloadArr.push({
          name: x.name
        });
      });
      var download = [];
      this.prepareRateChart.series.forEach(function (_) {
        download.push({
          data: []
        });
      });
      this.availabilityForExcel.forEach(function (obj) {
        var availabilityRateActual = obj.availabilityRateActual === null ? null : obj.availabilityRateActual;
        var availabilityRateGoal = obj.availabilityRateGoal === null ? null : obj.availabilityRateGoal;
        var accAvaiActual = obj.accAvaiActual === null ? null : obj.accAvaiActual;
        download[0].data.push(availabilityRateActual);
        download[1].data.push(availabilityRateGoal);
        download[2].data.push(accAvaiActual);
      });
      this.prepareRateChart.xAxis.categories.forEach(function (x, xindex) {
        downloadArr.forEach(function (y, yindex) {
          y["".concat(x)] = download[yindex].data[xindex];
        });
      });
      downloadCsv(downloadArr, fields, this.filename);
    },
    avgPerpareRate: function avgPerpareRate() {
      var _this3 = this;
      this.prepareRateChart.series[2].data = [];
      var num = 0;
      this.prepareRateChart.series[0].data.forEach(function (x, idx) {
        num = num + x;
        var avg = dbDataHandle(num / (idx + 1));
        _this3.prepareRateChart.series[2].data.push(avg);
      });
    }
  },
  watch: {
    dataClassArr: function dataClassArr(newValue, oldValue) {
      var _this4 = this;
      var setData = [{
        name: '妥善率實際值',
        dataName: ['妥善率實際值 (%)']
      }, {
        name: '妥善率年度目標值',
        dataName: ['妥善率年度目標值 (%)']
      }, {
        name: '妥善率累積實際值',
        dataName: ['妥善率累積實際值 (%)']
      }];
      if (oldValue !== newValue) {
        this.prepareRateChart.series.forEach(function (x) {
          x.visible = false;
        });
        setData.forEach(function (x) {
          if (newValue.includes(x.name)) {
            x.dataName.forEach(function (y) {
              _this4.prepareRateChart.series.find(function (z) {
                return z.name === y;
              }).visible = true;
            });
          }
        });
      }
    }
  },
  mounted: function mounted() {
    var _this5 = this;
    return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _this5.avgPerpareRate();
            case 1:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }))();
  }
};